import { FC } from 'react';

import { Card } from 'components/primitives/Card';
import { Button, Center, Heading } from '@chakra-ui/react';

const ErrorFallback: FC = () => {
  return (
    <Center flex={1}>
      <Card p="10" borderRadius="10px" gap="20px">
        <Heading>Something went wrong</Heading>
        <Button as="a" href="/">
          Go to Home
        </Button>
      </Card>
    </Center>
  );
};

export default ErrorFallback;
